// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://itmloubearjobamjsomj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml0bWxvdWJlYXJqb2JhbWpzb21qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0NDA3NjIsImV4cCI6MjA1ODAxNjc2Mn0.2BCVOA_9YOyC4zwl7oBZ2uCopAgrnTIupZ5Rz42OFpc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);